<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>Bodega</h3>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12 col-md-6">
        <div class="form-field">
          <input-field
            placeholder="Digite un código..."
            id="codigo"
            name="codigo"
            v-model="form.codigo"
            :readonly="form.estado !== 'N'"
          >
            Código*
            <span
              v-if="errores.codigo"
              class="helper-text text-danger"
              slot="helper"
            >
              <strong>{{ errores.codigo[0] }}</strong>
            </span>
          </input-field>
        </div>
      </div>
      <div class="col-xs-12 col-md-6">
        <div class="form-field">
          <input-field
            placeholder="Digite un código..."
            id="codigo"
            name="codigo"
            v-model="form.codigo_sucursal"
          >
            Código de sucursal*
            <span
              v-if="errores.codigo_sucursal"
              class="helper-text text-danger"
              slot="helper"
            >
              <strong>{{ errores.codigo_sucursal[0] }}</strong>
            </span>
          </input-field>
        </div>
      </div>
      <div class="col-xs-12 col-md-6">
        <div class="form-field">
          <input-field
            id="descripcion"
            v-model="form.descripcion"
            placeholder="Escriba una descripción..."
          >
            Descripción*
            <span
              v-if="errores.descripcion"
              class="helper-text text-danger"
              slot="helper"
            >
              <strong>{{ errores.descripcion[0] }}</strong>
            </span>
          </input-field>
        </div>
      </div>
      <div class="col-xs-12 col-md-6">
        <div class="form-field">
          <input-field
            vMoney
            :format="money"
            id="descripcion"
            v-model="form.valor_caja_inicial"
            placeholder="Escriba una descripción..."
          >
            Valor inicial de caja*
            <span
              v-if="errores.valor_caja_inicial"
              class="helper-text text-danger"
              slot="helper"
            >
              <strong>{{ errores.valor_caja_inicial[0] }}</strong>
            </span>
          </input-field>
        </div>
      </div>
    </div>
    <div class="modal-buttons">
      <button @click="guardar" class="btn-success">
        <i class="fa fa-save"></i><span>Guardar</span>
      </button>
      <button @click="cancelar" class="btn-danger btn--text">
        <i class="fa fa-times"></i><span>Cancelar</span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      required: false,
      default: function () {
        return {
          codigo: "",
          descripcion: "",
          estado: "N",
          codigo_sucursal: "",
          valor_caja_inicial: 300
        };
      },
    },
  },
  data: function () {
    return {
      form: JSON.parse(JSON.stringify(this.value)),
      errores: {},
      money: money
    };
  },
  methods: {
    guardar: function () {
      swal({
        title: "¿Desea almacenar los datos de la bodega?",
        text: "Se requiere confirmación",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.value) {
          let urlRequest = url + "/inventario/bodegas";
          if (this.form.estado !== "N") {
            this.form._method = "PUT";
            urlRequest += "/" + this.form.id;
          } else this.form._method = undefined;
          axios
            .post(urlRequest, this.form)
            .then(() => {
              swal(
                "La bodega fue almacenada exitosamente.",
                "Realizado",
                "success"
              );
              this.$emit("saved");
            })
            .catch(({ response }) => {
              let status = response.status;
              if (status == 422) {
                this.errores = response.data.errors;
                swal("Hay errores en el formulario.", "Aviso", "warning");
              } else
                swal("Hubo un error, intente nuevamente.", "Error", "error");
            });
        }
      });
    },
    cancelar: function () {
      this.$emit("cancelar");
    },
  },
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/inventario/Bodega.vue